import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

export const uploadCoupaFile = async ([formData, controller]) => {
  const response = await axios.post(URLS.COUPA_FILE_UPLOAD, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    signal: controller.signal,
  });

  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response;
};
